<template>
  <div class="trainers-list mobile-trainers-list">
    <div id="mobileTrainersList">
      <TrainerCard
        v-for="trainer in mobileTrainersList"
        :id="`id-${trainer.id}`"
        :key="trainer.id"
        :trainer="trainer"
      />
    </div>
    <div v-if="isVisible && !isEmpty" class="loader-wrapper">
      <vue-loaders name="ball-beat" scale="1" color="#2f8e97" />
    </div>
    <div v-if="isEmpty && !isLoading" class="loader-wrapper">
      <p>{{ $t('common.no_trainers') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TrainerCard from '@/components/Search/TrainerCard'

export default {
  name: 'MobileList',
  components: {
    TrainerCard
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    pagesNumber: {
      type: Number,
      default: 1
    },
    isEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 1,
      listWrapper: null,
      mobileTrainersList: [],
      footerHeight: null,
      isLoading: true,
      loadNew: true,
      CACHED_PATHS: [
        'location-trainer-id',
        'location-club-id',
        'location-search-trainers-all'
      ]
    }
  },
  computed: {
    ...mapGetters({
      cachedPage: 'search/searchPage',
      cachedTrainers: 'search/getCachedTrainers',
      focusedTrainer: 'search/getFocusedTrainer'
    }),
    isVisible() {
      //  is loader visible
      return (
        !this.mobileTrainersList.length ||
        this.isLoading ||
        this.pagesNumber !== this.currentPage
      )
    },
    isPageReload() {
      return 0
    },
    currentLocale() {
      return this.$i18n.locale
    }
  },
  watch: {
    list(val) {
      //  is loaded trainers number > 0
      //  and if this trainers haven`t been loaded yet
      if (val.length && !this.isListDuplicated()) {
        //  add new loaded trainers on the page
        this.mobileTrainersList.push(...this.list)

        //  allow to load new trainers
        this.loadNew = true

        if (this.pagesNumber <= this.currentPage) {
          this.isLoading = false
        }
      }
    },
    currentLocale() {
      //  clear list and load trainers when locale changes
      this.clearTrainersList()
    }
  },
  created() {
    if (this.cachedTrainers) {
      this.mobileTrainersList = []
      this.mobileTrainersList.push(...this.cachedTrainers)
      this.currentPage = this.cachedPage
    }
  },
  mounted() {
    this.handleScrollMobile()
    this.$bus.$on('clearList', (val) => this.clearTrainersList(val))

    this.focusTrainer()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.infiniteHandler)
    this.$bus.$off('clearList')

    const cachedRoute = this.CACHED_PATHS.some((item) =>
      this.$route.name.includes(item)
    )

    //  cache trainers list only if transition to CACHED_PATHS
    //  and if it`s loaded
    cachedRoute &&
      this.mobileTrainersList.length &&
      this.cacheTrainers(this.mobileTrainersList)

    this.clearTrainersList(true)
  },
  methods: {
    ...mapActions({
      cacheTrainers: 'search/CACHE_TRAINERS'
    }),
    infiniteHandler() {
      if (this.listWrapper) {
        const listHeight = this.listWrapper.getBoundingClientRect().height
        const scrolled = window.scrollY

        if (
          this.mobileTrainersList?.length &&
          listHeight <= this.footerHeight + scrolled + 500 &&
          this.loadNew
        ) {
          if (this.currentPage < this.pagesNumber) {
            //  increase page number and this will initialize
            //  new trainers loading
            this.currentPage += 1

            this.$emit('changePageMobile', this.currentPage)
            //  forbid new trainers loading (while previous are not loaded)
            this.loadNew = false
          } else {
            this.isLoading = false

            //  remove event listener when all trainers are loaded
            window.removeEventListener('scroll', this.infiniteHandler)
          }
        }
      }
    },
    handleScrollMobile() {
      const footer = document.querySelector('#footer')
      this.listWrapper = document.querySelector('#mobileTrainersList')
      this.footerHeight = footer.getBoundingClientRect().height

      if (this.pagesNumber === 1) {
        this.isLoading = false
      }

      window.addEventListener('scroll', this.infiniteHandler)
    },
    isListDuplicated() {
      // prevent duplication of trainers
      const arr1Length = this.list.length - 1
      const arr2Length = this.mobileTrainersList.length - 1

      return (
        this.list[arr1Length] &&
        this.mobileTrainersList[arr2Length] &&
        this.list[arr1Length].id === this.mobileTrainersList[arr2Length].id
      )
    },
    clearTrainersList(destroy) {
      this.mobileTrainersList = []
      this.currentPage = 1
      this.isLoading = true
      this.loadNew = true

      //  re-add event listener for scroll
      //  after every new query (besides page number change)
      if (!destroy) {
        this.$emit('changePageMobile', this.currentPage)
        this.handleScrollMobile()
      }
    },
    focusTrainer() {
      if (this.focusedTrainer && this.mobileTrainersList.length) {
        const stringID = `#id-${this.focusedTrainer}`

        try {
          const focusOn = document
            .querySelector(stringID)
            .getBoundingClientRect().top
          window.scrollTo({
            top: focusOn - 100,
            behavior: 'smooth'
          })
        } catch (err) {
          //  eslint-disable-next-line
          console.log(err)
          this.clearTrainersList(true)
        }
      }
    }
  }
}
</script>

<style scoped>
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100px;
}
</style>
